import Grid from '../../../fragments/Grid'
import classes from './Box.module.css'  

export default function PendingTaksBox({summary}) {
    return <div className={`${classes.item} ${classes.pending_tasks_box}`} >
        <div className={`${classes.pending_tasks_box_item} ${classes.pending_tasks_box_item_large}`}>
            {/* <div className={classes.title_large}>Pending tasks</div> 
            <div className={classes.description_large}>{summary.my_pending_tasks ? summary.my_pending_tasks : 'No pending tasks'}</div> */}

            {summary.my_pending_tasks ? <>
                <div className={classes.title_large}>Pending tasks</div> 
                <div className={classes.description_large}>{summary.my_pending_tasks}</div>
            </> : <>
                <div className={classes.title_large}>No pending tasks</div>
            </>}
        </div>

        <div className={classes.flex_container}>
            <Grid columns="2" gap={8}>
                <div className={classes.pending_tasks_box_item}><div>Overdue</div> <div className={classes.pending_tasks_box_item_value}>{summary.overdue_tasks? summary.overdue_tasks : 0}</div></div>
                <div className={classes.pending_tasks_box_item}><div>Due today</div> <div className={classes.pending_tasks_box_item_value}>{summary.due_today? summary.due_today : 0}</div></div>
            </Grid>
            <Grid columns="3" gap={8}>                
                <div className={`${classes.pending_tasks_box_item} ${classes.box_high}`}><div className={classes.title_small}>High priority</div> <div className={classes.pending_tasks_box_item_value}>{summary.high_priority_pending_tasks? summary.high_priority_pending_tasks : 0}</div></div>
                <div className={`${classes.pending_tasks_box_item} ${classes.box_medium}`}><div className={classes.title_small}>Medium priority</div> <div className={classes.pending_tasks_box_item_value}>{summary.medium_priority_pending_tasks? summary.medium_priority_pending_tasks : 0}</div></div>
                <div className={`${classes.pending_tasks_box_item} ${classes.box_low}`}><div className={classes.title_small}>Low priority</div> <div className={classes.pending_tasks_box_item_value}>{summary.low_priority_pending_tasks? summary.low_priority_pending_tasks : 0}</div></div>
            </Grid>
        </div>
    </div>
}